function initReservationForm() {
    let activeYear = $('.years__item--active').attr('data-year');
    let activeMonth = $('.years__list').attr('data-current-month');

    // init
    let $activeNavYear = $(`.years__item[data-year='${activeYear}']`);
    let $activeNavMonth = $(`.months__item[data-month='${activeMonth}'][data-year='${activeYear}']`);
    let $activeYearCalendar = $(`.calendars[data-year='${activeYear}']`);
    let $activeMonth = $(`.calendar[data-year='${activeYear}'][data-month='${activeMonth}']`);
    $activeNavMonth.addClass('months__item--active');
    $activeYearCalendar.addClass('calendars--active');
    $activeMonth.addClass('calendar--active');
    $activeNavMonth.siblings().removeClass('months__item--active');

    $('.years__item__link').on('click', function(event) {
        event.preventDefault();
        $activeNavYear.removeClass('years__item--active');

        activeYear = $(this).attr('data-year');
        $activeNavYear = $(`.years__item[data-year='${activeYear}']`);
        $activeNavYear.addClass('years__item--active');
        $('.calendars--active').removeClass('calendars--active');
        $(`.calendars[data-year='${activeYear}']`).addClass('calendars--active');

        // no open calendar in selected year
        if ($('.calendars--active .calendar--active').length === 0) {
            $('.calendars--active .calendar').first().addClass('calendar--active');
            activeMonth = $('.calendars--active .calendar--active').attr('data-month');
            let $activeNavMonth = $(`.months__item[data-month='${activeMonth}'][data-year='${activeYear}']`);
        }

    });

    $('.months__item__link').on('click', function(event) {
        event.preventDefault();
        $('.calendars--active .months__item--active').removeClass('months__item--active');
        $('.calendars--active .calendar--active').removeClass('calendar--active');

        activeMonth = $(this).attr('data-month');
        $activeMonth = $(`.calendar[data-year='${activeYear}'][data-month='${activeMonth}']`);
        $activeMonth.addClass('calendar--active');
        $activeNavMonth = $(`.months__item[data-month='${activeMonth}'][data-year='${activeYear}']`);
        $activeNavMonth.addClass('months__item--active');
    });

     /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Attendees Range Slider

    */
    const $attendeesText = $('.reservationcalendar-form__attendees__text span');
    const $attendeesInput = $('.reservationcalendar-form__attendees__input');


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Modal

    */

    let $html = $('html');
    let $calendar_modal = $('.reservationcalendar-modal');
    let $calendar_modal_link_close = $('[data-reservationcalendar-modal-close]');
    let $available_days = $('.calendar__day--available, .calendar__day--rentable, .calendar__day--reserved');
    let $separee_days = $('.calendar__day--separee-available, .calendar__day--separee-reserved');
    let $minValueText = $attendeesInput.find("[data-attendees-min-text]")
    let $maxValueText = $attendeesInput.find("[data-attendees-max-text]")
    let $valueText = $(".reservationcalendar-form__attendees__text span")
    let $termsLink = $("[data-terms-separee]")
    let $tosLabelSeparee = $("#tos-separee")
    let $tosLabelDefault = $("#tos-default")
    // open
    $separee_days.on('click',function(e){

        let $separee_text = "Unverbindliche Anfrage für das Séparée am Dunnstig"
        $attendeesInput.find("input").attr("min", "20")
        $attendeesInput.find("input").attr("max", "59")
        $attendeesInput.find("input").attr("value", "20")
        $attendeesInput.find("input")[0].stepDown(1000)
        $valueText.text("20")
        $minValueText.text("20")
        $maxValueText.text("59")
        $tosLabelDefault.hide()
        $tosLabelSeparee.show()


        if ($termsLink.length > 0) {
            $termsLink.find("a").attr("href", $termsLink.data().termsSeparee)
        }


        $calendar_modal.find("form").find("input[name='is_separee']").attr("value", "Séparée mieten")


        // init
        let $trigger = $(this);
        e.preventDefault();
        // get/write dates
        let title_date = $trigger.attr('data-date-format-1');
        let heading_date = $trigger.attr('data-date-format-2');
        let input_date = $trigger.attr('data-date-format-3');
        $('.reservationcalendar-modal-content__heading').text($separee_text);
        $('.reservationcalendar-modal-header__heading').text(title_date);
        $('.reservationcalendar-modal-content__date').text(heading_date);
        $('.reservationcalendar-form__selected-date').val(input_date);
        // toggle classes
        $html.addClass('reservationcalendar-modal-visible');
        $html.addClass('scrolling-disabled');
        $calendar_modal.addClass('reservationcalendar-modal--visible');
    });

    $available_days.on('click',function(e){

        // init

        let $separee_text = "Unverbindliche Anfrage für"

        $attendeesInput.find("input").attr("min", "60")
        $attendeesInput.find("input").attr("max", "150")
        $attendeesInput.find("input").attr("value", "60")
        $attendeesInput.find("input")[0].stepDown(1000)
        $valueText.text("60")
        $minValueText.text("60")
        $maxValueText.text("150")
        $tosLabelDefault.show()
        $tosLabelSeparee.hide()

        if ($termsLink.length > 0) {
            $termsLink.find("a").attr("href", $termsLink.data().termsBar)
        }

        $calendar_modal.find("form").find("input[name='is_separee']").attr("value", "Barfussbar mieten")

        let $trigger = $(this);
        e.preventDefault();
        // get/write dates
        let title_date = $trigger.attr('data-date-format-1');
        let heading_date = $trigger.attr('data-date-format-2');
        let input_date = $trigger.attr('data-date-format-3');
        $('.reservationcalendar-modal-content__heading').text($separee_text);
        $('.reservationcalendar-modal-header__heading').text(title_date);
        $('.reservationcalendar-modal-content__date').text(heading_date);
        $('.reservationcalendar-form__selected-date').val(input_date);
        // toggle classes
        $html.addClass('reservationcalendar-modal-visible');
        $html.addClass('scrolling-disabled');
        $calendar_modal.addClass('reservationcalendar-modal--visible');
    });
    // close
    $calendar_modal_link_close.on('click',function(e){
        e.preventDefault();
        $html.removeClass('reservationcalendar-modal-visible');
        $html.removeClass('scrolling-disabled');
        $calendar_modal.removeClass('reservationcalendar-modal--visible');
    });

    // close modal when hitting ESC
    $(document).keydown(function(evt) {
        // init
        evt = evt || window.event;
        var isEscape = false;
        var $modal = $('.tingle-modal.default-modal');
        if ("key" in evt) {
            isEscape = evt.key == "Escape";
        } else {
            isEscape = evt.keyCode == 27;
        }
        if (isEscape) {
            // is default modal visible?
            if ($html.hasClass('reservationcalendar-modal-visible')) {
                $html.removeClass('reservationcalendar-modal-visible');
                $html.removeClass('scrolling-disabled');
                $calendar_modal.removeClass('reservationcalendar-modal--visible');
            }
        }
    });
}

$(document).on('input', '.reservationcalendar-form__attendees__input input[type="range"]', function (e) {
    $('.reservationcalendar-form__attendees__text span').text(e.target.value);
});

// init
$(function() {
    initReservationForm();
});

$(window).on('softpage:opened form-modal:opened default-modal:opened ajaxForm:success', function() {
    initReservationForm();
});



// WEBPACK FOOTER //
// ./static/js/modules/reservationcalendar.js